<template>
    <div class="card card-shadow last-progress-card" v-if="events.length > 0">
        <div class="card-top">
            <div class="card-inner secondary-c">
                <i class="fa fa-calendar-alt"></i>
                <h2>{{ $t('events.upcoming_events') }} {{ $t('events.plural').toLowerCase() }}</h2>
            </div>
        </div>

        <div class="card-inner">
            <div class="tw-flex tw-flex-col">
                <template v-for="tEvent in events">
                    <a :href="'/events/' + tEvent.slug" :key="tEvent.id">
                        <sidebar-event :tEvent="tEvent" :key="tEvent.id"></sidebar-event>
                    </a>
                </template>
                <a href="/events/" class="secondary-c tw-text-sm tw-mt-1" v-text="`${$t('events.view_all')} ${$t('events.plural').toLowerCase()}`"></a>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import HuddleEvent from '@/resources/assets/js/vue/lib/models/Event';
    import SidebarEvent from '@/resources/assets/js/vue/components/events/sidebar/SidebarEvent';

    export default {
        name: 'UpcomingEvents',

        components: {
            'sidebar-event': SidebarEvent,
        },

        computed: {
            events() {
               const sortedEvents = HuddleEvent.query().where((event) => {
                    const today = moment(new Date).format('YYYY-MM-DD HH:mm:ss');
                    return moment(event.start_date, 'MMMM DD, YYYY HH:mm').format('YYYY-MM-DD HH:mm:ss') > today;
                }).get().sort((a, b) => new Date(moment(a.start_date, 'MMMM DD, YYYY HH:mm').format()) - new Date(moment(b.start_date, 'MMMM DD, YYYY HH:mm').format()));

                return sortedEvents.slice(0, 5);
            },
        },

        methods: {
            fetchUpcomingEvents() {
                const params = new URLSearchParams();
                const today = moment(new Date).format('YYYY-MM-DD HH:mm:ss');

                params.append('where_gte', `start_date:${today}`);
                params.append('with', 'memberSelection');
                params.append('order_by', 'start_date:asc');
                params.append('sort_by_type', 'asc');
                params.append('size', 5);

                HuddleEvent.api().fetch(params, 'discover');
            },
        },

        mounted() {
            this.fetchUpcomingEvents();
        },

        updated() {
            if(typeof stickySidebar !== 'undefined') {
                stickySidebar.init();
            }
        },  
    };
</script>
